// https://github.com/biati-digital/glightbox
import 'glightbox/dist/css/glightbox.css';
import GLightbox from 'glightbox';


/**
 * Unlisted Vimeo URLs need ?h=hash on the player iframe.
 * GLightbox/Plyr often drop the hash from urls like vimeo.com/{id}/{hash}.
 */
function attachVimeoHashFix(instance) {
    instance.on('slide_after_load', (data) => {
        const href = data?.slideConfig?.href;
        if (!href || href.indexOf('vimeo') === -1) {
            return;
        }

        const match = href.match(/^(?:.*vimeo\.com\/|.*video\/)?(\d+)(?:\?.*&*h=|\/)+([\da-f]+)/i);
        if (!match) {
            return;
        }

        const iframe = data.slideNode?.querySelector('iframe');
        if (!iframe || !iframe.src) {
            return;
        }

        const hash = match[2];
        if (iframe.src.indexOf('h=') !== -1) {
            return;
        }

        const joiner = iframe.src.indexOf('?') === -1 ? '?' : '&';
        iframe.src = `${iframe.src}${joiner}h=${hash}`;
    });
}

//standard lightbox
const lightbox = GLightbox();
attachVimeoHashFix(lightbox);

//search box header
$(document).ready(function() {

    const teambox = GLightbox({
        touchNavigation: false,
        touchFollowAxis: false,
        keyboardNavigation: false,
        selector: ".teamboxlink",
        zoomable: false,
        draggable: false,
        height: 'auto',
        skin: 'teambox'
    });
    teambox.on('open', () => {
        $('.button--close--teambox').click(function() {
            teambox.close();
        })
    });

    

    const searchbox = GLightbox({
        touchNavigation: false,
        touchFollowAxis: false,
        keyboardNavigation: false,
        selector: ".searchboxlink",
        zoomable: false,
        draggable: false,
        height: 'auto'
    });
    searchbox.on('open', () => {
        $('input[type="search"]').select();
        $('.button--close').click(function() {
            searchbox.close();
        })
    });

});
